export const Months = [
    'Janvier',
    'Fevrier',
    'Mars',
    'Avril',
    'Mai',
    'Juin',
    'Juillet',
    'Aout',
    'Septembre',
    'Octobre',
    'Novembre',
    'Décembre'
]
export const oneDay = 24 * 60 * 60 * 1000
export const oneWeek = 7 * 24 * 60 * 60 * 1000
export const oneMonth = 30 * 24 * 60 * 60 * 1000
export const oneYear = 365 * 24 * 60 * 60 * 1000
export const firstDayOfYear = new Date(new Date().getFullYear(), 0, 1)
export const firstDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1)

export const sortByDate = (list, field = "date") => {
    list.sort((a, b) => {
        a = new Date(a[field]);
        b = new Date(b[field]);
        if (a > b){
            return 1;
        }
        if (a < b){
            return -1;
        }
        return 0;
    });
    return list
} 
export const groupByMonth = (list, field) => {
    let groupList = {}
    list = sortByDate(list, field)
    list.forEach( item => {
        let key = Months[new Date(item[field]).getMonth()] +" "+ new Date(item[field]).getFullYear()
        if( !groupList[key] ) {
            groupList[key] = []
        }  
        groupList[key].push(item)
    })
    return groupList
}
export const groupByDate = (list, field) => {
    let groupList = {}
    list = sortByDate(list, field)
    list.forEach( item => {
        let key = new Date(item[field]).toLocaleDateString("fr-FR")
        if( !groupList[key] ) {
            groupList[key] = []
        }  
        groupList[key].push(item)
    })
    return groupList
}
export const groupBy = (list, field) => {
    let groupList = {}
    list.forEach( item => {
        if( !groupList[item[field]] ) {
            groupList[item[field]] = []
        }  

        groupList[item[field]].push(item)
    })
    return groupList
}

export const sumList = (list, field, val) => {
    return list.reduce( (acc, obj) => {
        var key = obj[field]            
        var value = obj[val]            
        
        if(!acc[key]){
            acc[key] = 0;
        }
        acc[key] += value ;
        return acc;
    }, {});
}
export const countList = (list, field) => {
    return list.reduce( (acc, obj) => {
        var key = obj[field]            
        
        if(!acc[key]){
            acc[key] = 0;
        }
        acc[key] ++;
        return acc;
    }, {});
}
export const count = (list) => {
    return list.reduce( (acc, obj) => {
        
        if(!acc[obj]){
            acc[obj] = 0;
        }
        acc[obj] ++;
        return acc;
    }, {});
}
export const getLimitDate = (period) => {
    let dateLimit = Date.now() - oneWeek
    console.log('====================================');
    console.log({firstDayOfMonth});
    console.log('====================================');
    switch (period) {
        case "week":
            dateLimit = Date.now() - oneWeek
            break;
        case "month":
            dateLimit = Date.now() - oneMonth
            break;
        case "currentMonth":
            dateLimit = firstDayOfMonth
            break;
        case "year":
            dateLimit = firstDayOfYear
            break;
        default:
            break;
    }
    return dateLimit
}
export const getDateLabels = (period, fullYear = new Date().getFullYear()) => {
    let dateLabels = []
    
    if (period === "year") {
        for(let i = 0; i < 12; i ++ ){
            dateLabels.push(Months[i] +" "+ fullYear) 
        }
    } else {
        let dateLimit = getLimitDate(period)
        for(let i = dateLimit; i < Date.now(); i += oneDay ){
            dateLabels.push(new Date(i).toLocaleDateString("fr-FR") ) 
        }
    }
    return dateLabels
}

export const getLabelsCustom = (startDate, endDate) => {
    let dateLabels = []

    let start_year = new Date(startDate).getFullYear()
    let end_year = new Date(endDate).getFullYear()
    let nbYears = end_year - start_year

    if (nbYears > 0 ){
        for(let year = start_year; year <= end_year; year ++ ){

            let firstMonth = year === start_year ? new Date(startDate).getMonth() : 0
            let lastMonth = year === end_year ? new Date(endDate).getMonth() : 11

            for(let i = firstMonth; i <= lastMonth; i ++ ){
                dateLabels.push(Months[i] +" "+ year ) 
            }
        }
        
    } else {
        for(let i = new Date(startDate).getMonth(); i <= new Date(endDate).getMonth(); i ++ ){
            dateLabels.push(Months[i] +" "+ start_year ) 
        }
    }
    
    return dateLabels
}

